import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

export default function BulletList ({
  list,
  extraClass,
  itemExtraClass,
  inlineCentered = true
}) {
  return (
    <ul className={classnames(extraClass, 'bullet-list')}>
      {list.map((item, idx) => {
        return (
          <li
            key={idx}
            className={classnames(
              'bullet-list__item',
              {
                'inline-flex items-center mb1': inlineCentered
              },
              itemExtraClass
            )}
          >
            {item}
          </li>
        )
      })}
    </ul>
  )
}

BulletList.propTypes = {
  list: PropTypes.array,
  extraClass: PropTypes.string
}
